import { render, staticRenderFns } from "./GoodsKeywordSearch.vue.js?vue&type=template&id=4711511a&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=template&id=4711511a&scoped=true"
import script from "./GoodsKeywordSearch.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=script&lang=js"
export * from "./GoodsKeywordSearch.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=script&lang=js"
import style0 from "./GoodsKeywordSearch.vue.scss?vue&type=style&index=0&id=4711511a&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=style&index=0&id=4711511a&lang=scss&scoped=true"
import style1 from "./GoodsKeywordSearch.vue.css?vue&type=style&index=1&id=4711511a&lang=css!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=style&index=1&id=4711511a&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4711511a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4711511a')) {
      api.createRecord('4711511a', component.options)
    } else {
      api.reload('4711511a', component.options)
    }
    module.hot.accept("./GoodsKeywordSearch.vue.js?vue&type=template&id=4711511a&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./GoodsKeywordSearch.vue?vue&type=template&id=4711511a&scoped=true", function () {
      api.rerender('4711511a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/GoodsKeywordSearch.vue"
export default component.exports